module.exports = __webpack_public_path__ + "static/media/popup-won-background.1fa0268f.png";